import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, User } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";

import { API } from "@/lib/apiBase";
import { setAdminToken } from "@/lib/adminAuth";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const { data } = await axios.post(`${API}/admin/login`, {
        username,
        password,
      });

      if (data?.access_token) {
        setAdminToken({
          access_token: data.access_token,
          expires_at: data.expires_at,
        });
        localStorage.setItem("admin_username", data.username);
        toast.success("Login successful!");
        navigate("/admin/dashboard");
      } else {
        toast.error("Login failed — missing access token");
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="flex justify-center mb-2">
            <img
              src="/assenda-logo.png"
              alt="Assenda"
              className="h-12 sm:h-16 w-auto object-contain"
              data-testid="brand-logo"
            />
          </h1>
          <p className="text-[#a1a1aa]">Admin Portal</p>
        </div>

        <div className="card-surface p-8">
          <h2 className="text-2xl font-bold mb-6 text-center">Admin Login</h2>
          
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="label-text block mb-2">Username</label>
              <div className="relative">
                <User className="absolute left-3 top-1/2 -translate-y-1/2 text-[#a1a1aa] pointer-events-none" size={20} />
                <input
                  data-testid="admin-username-input"
                  type="text"
                  className="input-field !pl-12"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  placeholder="Enter username"
                />
              </div>
            </div>

            <div>
              <label className="label-text block mb-2">Password</label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-[#a1a1aa] pointer-events-none" size={20} />
                <input
                  data-testid="admin-password-input"
                  type="password"
                  className="input-field !pl-12"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  placeholder="Enter password"
                />
              </div>
            </div>

            <button
              data-testid="admin-login-button"
              type="submit"
              disabled={loading}
              className="btn-primary w-full disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? "Logging in..." : "Login"}
            </button>
          </form>

          <div className="mt-6 text-center">
            <button
              data-testid="back-home-link"
              onClick={() => navigate("/")}
              className="text-sm text-[#a1a1aa] hover:text-[#8cc63f] transition-colors"
            >
              Back to Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
